"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ZachetaDoKontaktu() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="zachęta-do-kontaktu" className="relative overflow-hidden bg-dark-background py-32 md:py-40">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-fixed" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1539347/img/legal_consultation_office_interior.png)"
    }}>
        <div className="absolute inset-0 bg-dark-background/80 backdrop-blur-sm" />
      </div>

      {}
      <div ref={ref} className={`
          relative z-10 mx-auto max-w-4xl px-6 text-center
          transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]
          ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}
        `}>
        {}
        <h2 className="font-display text-4xl md:text-5xl font-semibold text-foreground-dark mb-6 leading-tight tracking-tight">
          Potrzebujesz pomocy prawnej?
        </h2>

        {}
        <p className="text-lg md:text-xl text-foreground-dark/90 mb-10 leading-relaxed max-w-2xl mx-auto">
          Skontaktuj się z nami, aby omówić Twoją sprawę. Zapewniamy rzetelną
          obsługę prawną na każdym etapie postępowania.
        </p>

        {}
        <Button asChild size="lg" className="
            bg-primary hover:bg-primary-hover active:bg-primary-active
            text-foreground-primary font-sans font-semibold uppercase tracking-wide
            px-10 py-5 rounded-md shadow-medium
            hover:shadow-strong hover:-translate-y-1
            active:translate-y-0
            transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)]
            focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
          ">
          <Link to="/ContactPage">Skontaktuj się z nami</Link>
        </Button>
      </div>
    </section>;
}